import React from 'react';
import '../ActivateWalletPrompt.css'; // ✅ reuse same styling
import { useTranslation } from 'react-i18next';

export default function MerchantWalletRequiredPrompt({
  onClose,
  onActivate,
  threshold = 0.1,
}) {
  const { t } = useTranslation();

  return (
    <div className="awp-backdrop" onClick={onClose}>
      <div className="awp-panel" onClick={(e) => e.stopPropagation()}>
        <div className="awp-grabber" />

        <h3 className="awp-title">
          {t('merchantWalletGate.title', 'Wallet required for merchants')}
        </h3>

        <p className="awp-subtitle">
          {t(
            'merchantWalletGate.subtitle',
            'To register as a merchant, your in-app Pi wallet must be active. This helps ensure merchants are properly verified in the Pi ecosystem.'
          )}
        </p>

        <ul className="awp-list">
          <li>
            {t(
              'merchantWalletGate.bullet1',
              'Activate once by topping up at least {{amount}} Pi.',
              { amount: threshold }
            )}
          </li>
          <li>
            {t(
              'merchantWalletGate.bullet2',
              'Get paid in Pi for marketplace orders directly in BarterFi.'
            )}
          </li>
          <li>
            {t(
              'merchantWalletGate.bullet3',
              'Active wallets help improve trust and reduce fake merchant registrations.'
            )}
          </li>
        </ul>

        <div className="awp-actions">
          <button className="awp-btn awp-btn-primary" onClick={onActivate}>
            {t('merchantWalletGate.activate', 'Go to Wallet')}
          </button>

          <button className="awp-btn awp-btn-secondary" onClick={onClose}>
            {t('merchantWalletGate.later', 'Not now')}
          </button>
        </div>

        <p className="awp-footer-hint">
          {t(
            'merchantWalletGate.hint',
            'Once activated, you can come back and submit your merchant application.'
          )}
        </p>
      </div>
    </div>
  );
}
